var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoconut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86263 11.9231C3.17566 13.1264 2.63788 14.4075 2.25684 15.7346H25.0304C25.4316 15.7346 25.8017 15.9505 25.9993 16.2995L27.1671 18.3627L28.1057 16.3729C28.2895 15.9833 28.6817 15.7346 29.1125 15.7346H35.7807C35.3996 14.4074 34.8619 13.1264 34.1749 11.9231C33.9767 11.5761 33.6077 11.3618 33.2081 11.3618H4.82948C4.42981 11.3618 4.0608 11.5761 3.86263 11.9231Z",
    fill: "#5A4236"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8181 17.961L28.2637 21.2563C28.0863 21.6325 27.7139 21.8784 27.2982 21.8939C27.2843 21.8944 27.2704 21.8946 27.2566 21.8946C26.8567 21.8946 26.486 21.6797 26.2879 21.3297L24.3811 17.961H1.77175C1.64291 18.8181 1.57715 19.6865 1.57715 20.5586C1.57715 25.2174 3.39135 29.5973 6.68563 32.8915C9.97983 36.1858 14.3598 38 19.0185 38C23.6772 38 28.0572 36.1858 31.3514 32.8915C34.6457 29.5973 36.4599 25.2174 36.4599 20.5586C36.4599 19.6865 36.3941 18.818 36.2652 17.9609H29.8181V17.961Z",
    fill: "#5A4236"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24444 8.48348L6.62088 9.13542H9.19189L8.17272 7.37019L12.7472 4.72912C13.1323 4.50676 13.3482 4.07644 13.2962 3.63476C13.2442 3.19301 12.9342 2.82466 12.5079 2.6979L3.59238 0.0465798C3.29921 -0.0406273 2.98326 -0.00336941 2.71838 0.149521C2.45356 0.302412 2.26327 0.557502 2.19224 0.854897L0.0305429 9.90165C-0.0728439 10.3343 0.0911797 10.7868 0.447727 11.0527C0.644184 11.1993 0.878344 11.2737 1.11347 11.2737C1.30495 11.2737 1.49711 11.2243 1.67004 11.1245L6.24444 8.48348Z",
    fill: "#5A4236"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9077 0H31.3243C30.8989 0 30.5107 0.242399 30.324 0.6247L26.167 9.13515H28.645L32.0195 2.22664H36.9077C37.5225 2.22664 38.021 1.72819 38.021 1.11336C38.021 0.498528 37.5225 0 36.9077 0Z",
    fill: "#5A4236"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoconut);
export default __webpack_public_path__ + "static/media/coconut.056466ab53e0461e1de0caca3be0c0fb.svg";
export { ForwardRef as ReactComponent };